import { Element, Tile } from 'react-bulma-components';
import React, { Fragment, useEffect, useState } from 'react';
import { faCaretDown as contextIcon, faAngleDown, faArchive, faFilePowerpoint, faFolder, faFolderOpen } from '@fortawesome/free-solid-svg-icons';
import { gql, useQuery } from '@apollo/client';

import DefaultError from '../components/defaulterror';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Loader from '../components/loader';
import ReactTooltip from 'react-tooltip';

export const GET_FOLDER = gql`
  query GetFolder($name: String, $id: String) {
    folder(name: $name, id: $id)
    {
      id
      name
      items {
        name
        kind
        id
      }
    }
  }
`;

const Folder = ({ id, name, path, setPath, onItemSelect, currentItemId, setCurrentItemId}) => {
  const { data, loading, error } = useQuery(GET_FOLDER,
    {
      variables: { name: name, id: id },
    });
  useEffect(() => {
    ReactTooltip.rebuild();
  });
  if (error) {
    return (
      <Fragment>
        <DefaultError error={error} />
      </Fragment>
    );
  }
  if (loading) return <Loader />;
  if (name) {
    return(
      <FolderItem 
                item={data.folder} 
                open={true}
                parentId={null}
                path={path}
                setPath={setPath} 
                key={1} 
                onItemSelect={onItemSelect} 
                currentItemId={currentItemId} 
                setCurrentItemId={setCurrentItemId}/>
    )
  }
  else {
    return (
      <Tile kind="parent" vertical>
            {data.folder && data.folder.items && [...data.folder.items].filter(a => a.kind==='dir').sort((a, b) => a.name > b.name? 1:-1).map((item, i) =>
              <FolderItem 
                item={item} 
                parentId={id} 
                key={i} 
                path={path}
                setPath={setPath} 
                onItemSelect={onItemSelect} 
                currentItemId={currentItemId} 
                setCurrentItemId={setCurrentItemId}/>
            )}
            {data.folder && data.folder.items && [...data.folder.items].filter(a => a.kind!=='dir').sort((a, b) => a.name > b.name? 1:-1).map((item, i) =>
              <FolderItem 
                item={item} 
                parentId={id} 
                key={i} 
                path={path}
                setPath={setPath} 
                onItemSelect={onItemSelect} 
                currentItemId={currentItemId} 
                setCurrentItemId={setCurrentItemId}/>
            )}
      </Tile>
    )
  }
}

const FolderItem = ({ item, parentId, open, path, setPath, onItemSelect, currentItemId, setCurrentItemId }) => {
  const [openDir, setOpenDir] = useState(open);
  const [showContent, setShowContent] = useState(open);

  var icon;
  var iconColor;
  var isRoot = parentId===null;
  var strObj = JSON.stringify({ pid: parentId, r: isRoot, id: item.id, n: item.name, k: item.kind });
  switch (item.kind) {
    case "exc":
      icon = faFilePowerpoint;
      iconColor = "blue";
      break;
    default:
      icon = showContent ? faFolderOpen : faFolder;
      iconColor = "orange";
      break;
  }
  if(parentId===null)
  {
    icon = faArchive;
    iconColor = "darkgray";
  }
  const handleItemClick = (e) => {
    
    
    if(item.kind==="dir" || item.kind===undefined)
    {
      setPath(path+item.name+'/');
      if(showContent && item.id===currentItemId)
      {
        setShowContent(!showContent);
      }
      else{
        setShowContent(true);
      }
      setOpenDir(true);
    }
    else{
      setPath(path+item.name);
      
    }
    setCurrentItemId(item.id);
    if(onItemSelect)
      {
        onItemSelect(item)
      };
  }

  useEffect(() => {
    ReactTooltip.rebuild();
  });
  return (
    <Tile kind="child" >
      <span onClick={handleItemClick} style={{ cursor: "pointer" }}>
        <FontAwesomeIcon icon={icon} color={iconColor}/>
        {currentItemId===item.id ? 
          <strong>&nbsp;{item.name}</strong>
          :
          <>&nbsp;{item.name}</>
        }
      </span>&nbsp;
      {currentItemId===item.id && 
        <FontAwesomeIcon data-tip={strObj} data-for="folderContext" data-event="click" icon={contextIcon} color="gray" />
      }
      {(item.kind === "dir" || item.kind === undefined ) && openDir && 
        <Element hidden={!showContent}>
          <Folder 
            id={item.id} 
            path={path+item.name+'/'} 
            setPath={setPath}  
            onItemSelect={onItemSelect} 
            currentItemId={currentItemId} 
            setCurrentItemId={setCurrentItemId} />
        </Element>
      }
    </Tile>
  )
}



export default Folder;